import { Component, ErrorInfo, ReactNode } from 'react';

import ErrorView from './ErrorView';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // ONLY LOG IN DEVELOPMENT TO AVOID EXPOSING ERROR DETAILS IN PRODUCTION
    if (process.env.NODE_ENV === 'development') {
      console.error('Payment Error:', error, errorInfo);
    }
    else{
      // PRODUCTION: SEND TO ERROR TRACKING SERVICE
      // NOTE: Implement your error tracking service here (e.g., Sentry, LogRocket)
      // Example for Sentry:
      // Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });

      // For now, log minimal sanitized info
      console.error('An error occurred in the payment module');
    }
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      return fallback || <ErrorView />;
    }

    return children;
  }
}
